var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMyWebpage = function SvgMyWebpage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.125 6.75C11.125 6.33579 11.4608 6 11.875 6H15C15.4142 6 15.75 6.33579 15.75 6.75C15.75 7.16421 15.4142 7.5 15 7.5H11.875C11.4608 7.5 11.125 7.16421 11.125 6.75Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.125 9.25C11.125 8.83579 11.4608 8.5 11.875 8.5H15C15.4142 8.5 15.75 8.83579 15.75 9.25C15.75 9.66421 15.4142 10 15 10H11.875C11.4608 10 11.125 9.66421 11.125 9.25Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19531 6.25C6.57399 6.25 6.07031 6.75368 6.07031 7.375C6.07031 7.99632 6.57399 8.5 7.19531 8.5C7.81663 8.5 8.32031 7.99632 8.32031 7.375C8.32031 6.75368 7.81663 6.25 7.19531 6.25ZM4.57031 7.375C4.57031 5.92525 5.74557 4.75 7.19531 4.75C8.64506 4.75 9.82031 5.92525 9.82031 7.375C9.82031 8.82475 8.64506 10 7.19531 10C5.74557 10 4.57031 8.82475 4.57031 7.375Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19531 9.99509C6.80674 9.99509 6.42922 10.1244 6.12226 10.3627C5.81531 10.6009 5.59638 10.9346 5.5 11.311C5.39726 11.7123 4.98868 11.9543 4.58741 11.8516C4.18614 11.7488 3.94413 11.3402 4.04688 10.939C4.22587 10.2399 4.63245 9.62025 5.2025 9.17776C5.77256 8.73527 6.47367 8.49509 7.19531 8.49509C7.91695 8.49509 8.61807 8.73527 9.18812 9.17776C9.75818 9.62025 10.1648 10.2399 10.3438 10.939C10.4465 11.3402 10.2045 11.7488 9.80322 11.8516C9.40195 11.9543 8.99337 11.7123 8.89063 11.311C8.79424 10.9346 8.57532 10.6009 8.26837 10.3627C7.96141 10.1244 7.58389 9.99509 7.19531 9.99509Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 1.5V14.5H17.75V1.5H2.25ZM0.75 1.375C0.75 0.615608 1.36561 0 2.125 0H17.875C18.6344 0 19.25 0.615608 19.25 1.375V14.625C19.25 15.3844 18.6344 16 17.875 16H2.125C1.36561 16 0.75 15.3844 0.75 14.625V1.375Z",
    fill: "#666666"
  })));
};
export default SvgMyWebpage;